import React from 'react'
import { TextInput, type TextInputProps } from '@mantine/core'

export type AppInputProps = TextInputProps

/** Standard text input with consistent sizing and padding. */
export default function AppInput ({ size = 'sm', ...props }: AppInputProps) {
  return <TextInput radius="sm" size={size} {...props} />
}
